import * as React from 'react';
import { PageProps, Link } from 'gatsby';
import classNames from 'classnames';
import { UseCaseItemProps } from '../../types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const UseCaseItem: React.FC<PageProps<UseCaseItemProps>> = ({ data }) => {
  const useCaseItemClasses = classNames(
    'lg:first:col-span-2 group/use-case relative overflow-hidden cursor-pointer',
    'h-[31.25rem] rounded-[1.875rem] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)]',
    'after:transition-all after:duration-500 after:ease-in-out',
    'hover:after:bg-black/25 hover:after:absolute hover:after:top-0',
    'hover:after:left-0 hover:after:w-full hover:after:h-full hover:after:z-0'
  );

  const useCaseBackgroundClasses = classNames(
    'absolute top-0 left-0 object-cover object-center w-full h-full'
  );

  const useCaseOverlayClasses = classNames(
    'z-10 absolute bottom-0 left-0 px-[2.81rem] pt-[1.81rem] pb-[2.69rem] w-full',
    'backdrop-blur-sm bg-black/30'
  );
  const useCaseTitleClasses = classNames(
    'transition-all ease-in-out duration-300',
    'text-title-3 text-center text-white lg:group-hover/use-case:mb-[1.19rem]'
  );

  const useCaseDescriptionClasses = classNames(
    'lg:max-h-0 lg:opacity-0 mt-[1.19rem] lg:mt-0 overflow-hidden text-label font-light text-white text-center',
    'transition-all ease-in-out duration-300',
    'group-hover/use-case:max-h-[12.12rem] group-hover/use-case:opacity-100'
  );

  return (
    <Link to={data.goTo} className={useCaseItemClasses}>
      <GatsbyImage
        image={getImage(data.backgroundImage)}
        alt={data.title}
        className={useCaseBackgroundClasses}
      />
      <div className={useCaseOverlayClasses}>
        <p data-test-id="use-case-item__title" className={useCaseTitleClasses}>
          {data.title}
        </p>
        <p
          data-test-id="use-case-item__excerpt"
          className={useCaseDescriptionClasses}
        >
          {data.excerpt}
        </p>
      </div>
    </Link>
  );
};

export default UseCaseItem;
